const viewPassword = `<svg xmlns="http://www.w3.org/2000/svg" focusable="false" width="17" height="9" viewBox="0 0 17 9">
<path fill="#00A3E0" fill-rule="evenodd" d="M10 4.5c0 .86-.746 1.558-1.667 1.558-.92 0-1.666-.697-1.666-1.558 0-.86.746-1.557 1.666-1.557C9.254 2.943 10 3.64 10 4.5M8.333 7.443C5.843 7.443 3.496 6.336 2 4.5c1.497-1.835 3.843-2.943 6.334-2.943 2.491 0 4.838 1.108 6.335 2.943-1.497 1.836-3.844 2.943-6.335 2.943m0-7.443C4.77 0 1.666 1.813 0 4.5 1.666 7.188 4.77 9 8.333 9c3.564 0 6.668-1.812 8.334-4.5C15 1.813 11.897 0 8.333 0"/>
</svg>

`;

export default viewPassword;
